<template>
  <v-col cols="12" class="m-0 p-0" v-if="tableDisplay == 'records'">
    <v-row>
      <v-col cols="12" v-if="selected.length > 0">
        <v-app-bar color="grey darken-3" dense dark>
          <v-toolbar-title class="overline"
            >{{ selected.length }} selected</v-toolbar-title
          >
          <v-divider class="mx-4" vertical></v-divider>
          <v-btn
            v-if="routeAccess != true"
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="editItem(item)"
            >Edit</v-btn
          >
          <v-btn
            v-if="routeAccess != true"
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="deleteItem(item.id)"
            >Delete</v-btn
          >
          <v-btn
            v-if="routeAccess != true"
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            >Move To Folder</v-btn
          >
          <v-btn
            v-if="routeAccess"
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="attachRecordsToRoute()"
            >Attach Records</v-btn
          >
        </v-app-bar>
      </v-col>
      <v-col cols="12" v-if="selected.length > 0">
        <v-text-field
          v-model="remarks"
          label="Remarks"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :single-select="false"
          show-select
          :headers="headers"
          :items="allUnsortedRecords"
          :items-per-page="10"
          class="elevation-2"
          item-key="name"
          :search="search"
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "RecordsListTable",
    props: {
      tableDisplay: String,
      search: String,
      isFetching: Boolean,
    },
    data() {
      return {
        singleSelect: false,
        dialog: false,
        categoryId: this.$route.params.id,
        errorMessage: null,
        filing: {
          id: "",
          title: "",
        },
        selected: [],
        category: {
          id: "",
          title: "",
        },
        folder: {
          id: "",
          title: "",
        },
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: true,
            value: "name",
          },
          { text: "Type", value: "type" },
          { text: "Title", value: "title" },
          { text: "Sender", value: "sender" },
          { text: "Address", value: "address" },
          { text: "Record Date", value: "nrecord_date" },
        ],
        editedIndex: -1,
        editedItem: {
          name: "",
          type: "",
          title: "",
          sender: "",
          address: "",
        },
        defaultItem: {
          name: "",
          type: "",
          title: "",
          sender: "",
          address: "",
        },
        remarks: "",
      };
    },
    computed: mapGetters(["allUnsortedRecords"]),
    methods: {
      ...mapActions(["attachRouteRecords", "attachChildSubrouteRecord"]),
      attachRecordsToRoute() {
        let body = {
          type: this.routeType,
          route_id: this.routeId,
          records: this.selected,
          remarks: this.remarks,
          request_id: this.requestId,
        };

        if (this.routeType != "subroute") {
          this.attachRouteRecords(body).then((result) => {
            if (result) {
              this.selected = [];
              this.$emit("showSnackbar", true);
            }
          });
        } else {
          body = Object.assign(body, {
            route_index: this.subRouteIndex,
            container: this.parentRouteId,
          });

          this.attachChildSubrouteRecord(body).then((result) => {
            if (result) {
              this.selected = [];
              this.$emit("showSnackbar", true);
            }
          });
        }
      },
    },
  };
</script>

<style></style>
